var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drag-container" }, [
    _c(
      "ul",
      { staticClass: "drag-list" },
      _vm._l(_vm.stages, function (stage) {
        var _obj
        return _c(
          "li",
          {
            key: stage,
            staticClass: "drag-column",
            class: ((_obj = {}), (_obj["drag-column-" + stage] = true), _obj),
          },
          [
            _c(
              "span",
              { staticClass: "drag-column-header" },
              [_vm._t(stage, [_c("h2", [_vm._v(_vm._s(stage))])])],
              2
            ),
            _c("div", { staticClass: "drag-options" }),
            _c(
              "ul",
              {
                ref: "list",
                refInFor: true,
                staticClass: "drag-inner-list",
                attrs: { "data-status": stage },
              },
              _vm._l(_vm.getBlocks(stage), function (block) {
                return _c(
                  "li",
                  {
                    key: block[_vm.idProp],
                    staticClass: "drag-item",
                    attrs: { "data-block-id": block[_vm.idProp] },
                  },
                  [
                    _vm._t(block[_vm.idProp], [
                      _c("strong", [_vm._v(_vm._s(block[_vm.statusProp]))]),
                      _c("div", [_vm._v(_vm._s(block[_vm.idProp]))]),
                    ]),
                  ],
                  2
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "drag-column-footer" },
              [_vm._t("footer-" + stage)],
              2
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }